import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import axios from "axios";

import Button from "../../../../component/Button/Button";
import { Col, Row, Modal } from "react-bootstrap";

import Toast from "../../../../component/Toast/Toast";
import check from "../../../../images/check.svg";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import config from "../../../../config/config";
import Ordering from "./Ordering";
import Quill from "quill";

const modules = {
  toolbar: {
    container: [
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ header: [1, 2, 3, false] }],
      [{ align: [] }],
      ["link", "email"], // <-- ADD CUSTOM BUTTON
      ["clean"],
    ],
    handlers: {
      email: function () {
        const email = prompt("Enter email address:");
        if (!email) return;

        const quill = this.quill;
        const range = quill.getSelection(true);

        // Insert the email text
        quill.insertText(range.index, email, "link", `mailto:${email}`);
        quill.setSelection(range.index + email.length);
      },
    },
  },
};

const formats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "list",
  "bullet",
  "align",
  "link",
];

const HomepageFAQ = () => {
  const [list, setList] = useState([]);
  const [show, setShow] = useState(false);
  const [type, setType] = useState("Add");
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [editId, setEditId] = useState("");

  const [toastlist, setToastList] = useState([]);
  const [orderingModalOpen, setOrderingModalOpen] = useState(false);
  const [errorQuestion, setErrorQuestion] = useState("");
  const [errorAnswer, setErrorAnswer] = useState("");
  const icons = Quill.import("ui/icons");

  icons["email"] = `
<svg viewBox="0 0 24 24">
  <path fill="currentColor" d="M20 4H4a2 2 0 0 0-2 2v12a2 
  2 0 0 0 2 2h16a2 2 0 0 0 
  2-2V6a2 2 0 0 0-2-2zm0 
  4l-8 5-8-5V6l8 5 8-5v2z"/>
</svg>`;

  // Show Toast
  const showToast = (mode) => {
    const toast = {
      id: Math.random(),
      title: "Success",
      description:
        mode === "delete"
          ? "FAQ deleted successfully"
          : `FAQ ${type === "Add" ? "added" : "updated"} successfully`,
      backgroundColor: "#329F33",
      icon: check,
    };
    setToastList([...toastlist, toast]);
  };

  // Load FAQ List (GET API)
  useEffect(() => {
    axios
      .get(`${config.api_url}homepage/faqs`)
      .then((res) => {
        const sortedData = res.data.sort((a, b) => a.position - b.position);
        setList(sortedData);
      })
      .catch((err) => {
        console.log("FAQ GET error:", err);
      });
  }, []);

  // Open modal in Add mode
  const handleAdd = () => {
    setShow(true);
    setType("Add");
    setQuestion("");
    setAnswer("");
  };

  const handleOpenOrderingModal = () => setOrderingModalOpen(true);
  const handleCloseOrderingModal = () => setOrderingModalOpen(false);

  // Open modal in Update mode
  const handleEdit = (row) => {
    setShow(true);
    setType("Update");
    setEditId(row._id);
    setQuestion(row.question);
    setAnswer(row.answer);
  };

  // DELETE API
  const handleDelete = (id) => {
    axios
      .delete(`${config.api_url}homepage/faq/delete`, {
        data: { id }, // IMPORTANT FIX
      })
      .then((res) => {
        setList(res.data.sort((a, b) => a.position - b.position));
        showToast("delete");
      })
      .catch((err) => {
        console.log("Delete error:", err);
      });
  };

  // ADD / UPDATE SUBMIT API
  const submit = () => {
    let isValid = true;

    // Reset errors
    setErrorQuestion("");
    setErrorAnswer("");

    // Validate Question
    if (!question.trim()) {
      setErrorQuestion("Question is required");
      isValid = false;
    }

    // Validate Answer (remove HTML tags, check actual text)
    const plainAnswer = answer.replace(/<[^>]+>/g, "").trim();
    if (!plainAnswer) {
      setErrorAnswer("Answer is required");
      isValid = false;
    }

    if (!isValid) return;

    // ---- ADD ----
    if (type === "Add") {
      axios
        .post(`${config.api_url}homepage/faq/new`, {
          question,
          answer,
        })
        .then((res) => {
          setList(res.data);
          showToast("success");
          setShow(false);
        })
        .catch((err) => console.log("Add error:", err));
    }
    // ---- UPDATE ----
    else {
      axios
        .post(`${config.api_url}homepage/faq/update`, {
          id: editId,
          question,
          answer,
        })
        .then((res) => {
          const sortedData = res.data.sort((a, b) => a.position - b.position);
          setList(sortedData);
          showToast("success");
          setShow(false);
        })

        .catch((err) => console.log("Update error:", err));
    }
  };

  return (
    <>
      <div className="addjobinlist text-right mb-4">
        <Button title="Add FAQ" onClick={handleAdd} />
        <Button title="View Ordering" onClick={handleOpenOrderingModal} />
      </div>

      <MaterialTable
        title="Homepage FAQ Section"
        columns={[
          { title: "Question", field: "question" },

          {
            title: "Answer",
            field: "answer",
            render: (rowData) => (
              <div
                dangerouslySetInnerHTML={{ __html: rowData.answer }}
                style={{ maxHeight: "120px", overflow: "hidden" }}
              />
            ),
          },

          {
            title: "Action",
            render: (rowData) => (
              <div className="d-f">
                <Button title=" Update" onClick={() => handleEdit(rowData)} />
                <Button
                  title=" Delete"
                  onClick={() => handleDelete(rowData._id)}
                />
              </div>
            ),
          },
        ]}
        data={list}
        options={{
          search: false,
          exportButton: false,
          actionsColumnIndex: -1,
          paging: true,
        }}
      />

      {/* ---------- Modal ---------- */}
      <Modal
        centered
        show={show}
        onHide={() => setShow(false)}
        dialogClassName="addbannerModel"
      >
        <Modal.Header closeButton></Modal.Header>

        <Modal.Body className="model">
          <div className="title">{type} FAQ</div>

          <Row>
            {/* --------- Question Label --------- */}
            <Col lg={3} className="column">
              <div className="titleitem">Question</div>
            </Col>

            {/* --------- Question Input + Error --------- */}
            <Col lg={9} className="column">
              <input
                type="text"
                value={question}
                onChange={(e) => {
                  setQuestion(e.target.value);
                  setErrorQuestion("");
                }}
              />

              {errorQuestion && (
                <small style={{ color: "red" }}>{errorQuestion}</small>
              )}
            </Col>

            {/* --------- Answer Label --------- */}
            <Col lg={3} className="column mt-3">
              <div className="titleitem">Answer</div>
            </Col>

            {/* --------- Answer Editor + Error --------- */}
            <Col lg={9} className="column mt-3">
              <ReactQuill
                value={answer}
                onChange={(value) => {
                  setAnswer(value);
                  setErrorAnswer("");
                }}
                modules={modules}
                formats={formats}
              />

              {errorAnswer && (
                <small style={{ color: "red" }}>{errorAnswer}</small>
              )}
              {/* <div className="example-box">
                <strong>Examples:</strong>
                <div>
                  • Email link:{" "}
                  <code>
                    &lt;a
                    href='mailto:customerservice@laxmihos.com'&gt;customerservice@laxmihos.com&lt;/a&gt;
                  </code>
                </div>
                <div>
                  • Website link:{" "}
                  <code>
                    &lt;a href="https://laxmihos.com/store-locator"&gt;Click
                    here&lt;/a&gt;
                  </code>
                </div>
              </div> */}
            </Col>
          </Row>

          <div className="btnContainer mt-4">
            <Button title="SUBMIT" onClick={submit} />
          </div>
        </Modal.Body>
      </Modal>

      <Toast toastList={toastlist} position="top-right" />
      <Ordering
        isOpen={orderingModalOpen}
        onClose={handleCloseOrderingModal}
        datas={list}
        moduleName="FAQs"
        base_url={`${config.api_url}homepage/faq`}
        onUpdateOrder={(newList) => setList(newList)}
      />
    </>
  );
};

export default HomepageFAQ;
